export class PriceModel {
spnPrice: string;
setValue(res){
if(res){
if(res['spnPrice']){this.spnPrice = res['spnPrice'];}
}
}
}